import { DomainFlowState } from "../types/DomainFlowState";

/**
 * Derive the next flow state when a taken domain is handled.
 */
export function deriveTakenState(
    userOwns: boolean | null,
    transfer: boolean | null
): DomainFlowState {
    // Step 1: Ask if user owns the domain (if unknown)
    if (userOwns === null) return "taken-other";
    
    // Step 2: If user owns the domain, ask about transfer management
    if (userOwns === true) {
        return transfer === true
            ? "taken-own-manage"  // User owns it and wants to transfer/manage it
            : transfer === false
                ? "taken-own-keep"   // User owns it but wants to keep it external
                : "taken-own-manage"; // User owns it, ask about transfer (default)
    }
    
    // Step 3: If user doesn't own the domain
    if (userOwns === false) {
        return "taken-own-keep"; // Go to "not owned" flow (try another or skip)
    }
    
    return "taken-other"; // Fallback
}